import * as tslib_1 from "tslib";
import { Validators } from '@angular/forms';
var CustomZip = /** @class */ (function (_super) {
    tslib_1.__extends(CustomZip, _super);
    function CustomZip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomZip.validate = function (control) {
        if (control.value && control.dirty) {
            var matches = control.value.match(/^([0-9]{5})(\-)?([0-9]{4})?$/);
            return matches ? null : { 'invalidZip': true };
        }
        else {
            return null;
        }
    };
    return CustomZip;
}(Validators));
export { CustomZip };
